import React, { useContext, useEffect, useState } from "react";
import { SidebarContext } from "../context/SidebarContext";
import { Icon } from "../assets/icons";
import { getTitleFromRoute } from "../utils/docTitle";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import DropdownMenu from "./ui/dropDown";
import { getSites, siteGet } from "../redux/api/siteAPI";
import { zoneGet } from "../redux/api/zoneAPI";
import {getPendingNotifications} from "../redux/api/notificationAPI"
import { getHostResources } from "../redux/api/systemAPI"
import Select from "react-select";
import { useDispatch, useSelector } from "react-redux";
import { setUserSite } from "../redux/actions/authActions";
import Button from "../components/ui/button";
import { validateUser } from "../model/UserModel";
import { getReport, getLatestAlerts, alertStatusUpdate, } from "../redux/api/alertAPI";
import { Modal } from "./modals";
import NotificationDropdown from "./dropdownMenu/NotificationDropdown";
import ContactSupportModal from './modals/ContactSupportModal';
import i18next from "i18next";
import { useTranslation } from "react-i18next";
import moment from "moment-timezone";
import { toast } from "react-toastify";
import { getCurrentWeather } from "../utils/weather";

const localSite = () => {
  const c = JSON.parse(localStorage.getItem("site"));
  return (c && (c.Site_ID || c.value)) ? { value: c.Site_ID || c.value, label: c.Name || c.label } : null;
};
function Header() {
  const { t } = useTranslation("Header");
  const location = useLocation();
  const languages = [
    { value: "en", label: t("english") },
    { value: "fr", label: t("french") },
    { value: "ar", label: t("arabic") },
  ];

  const { toggleSidebar } = useContext(SidebarContext);
  const [sitesList, setSitesList] = useState(null); // State for list of sites
  const [error, setError] = useState(null); // State for error handling
  const [site, setSite] = useState(null);
  const [loadingReport, setLoadingReport] = useState(false);
  const [isGenerateReportModalOpen, setIsGenerateReportModalOpen] =
    useState(false);
  const [showContactModal, setShowContactModal] = useState(false);
  const [notifications, setNotifications] = useState([]);
  const [isNotificationDropdownOpen, setIsNotificationDropdownOpen] = useState(false);
  const [alerts, setAlerts] = useState([]);
  const [notificationsLoading, setNotificationsLoading] = useState(true);

  const [currentDateTime, setCurrentDateTime] = useState(moment());
  const [weather, setWeather] = useState(null);
  const [weatherLoading, setWeatherLoading] = useState(false);
  const userData = useSelector((state) => state.auth.userData || null);
  const isAdmin = useSelector((state) => state.auth.isAdmin);
  const userSite = useSelector((state) => state.auth.site || null);
  const sitesRefreshToken = useSelector((state) => state.sites?.refreshToken);
  const userCompany = localStorage.getItem("company");

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentDateTime(moment());
    }, 1000);
    return () => clearInterval(timer);
  }, []);

  const [isFullscreen, setIsFullscreen] = useState(Boolean(document.fullscreenElement));

  useEffect(() => {
    const handleFullscreenChange = () => setIsFullscreen(Boolean(document.fullscreenElement));
    document.addEventListener("fullscreenchange", handleFullscreenChange);
    return () => document.removeEventListener("fullscreenchange", handleFullscreenChange);
  }, []);

  const toggleFullscreen = () => {
    if (document.fullscreenElement) {
      document.exitFullscreen();
    } else {
      document.documentElement.requestFullscreen().catch((err) => {
        console.error("Error attempting to enable fullscreen:", err);
      });
    }
  };

  const dispatch = useDispatch();
  const navigate = useNavigate();

  // const handleGenerateReport = async () => {
  //   // const companyID = company ? company.value : null;
  //   const api_url = "http://127.0.0.1:8000//report/1"
  //   if (api_url) {
  //     try {
  //       const response = await fetch(api_url, {
  //         method: 'GET',
  //         headers: {
  //           'Content-Type': 'application/json',
  //         },
  //       });

  //       if (!response.ok) {
  //         throw new Error('Failed to fetch report');
  //       }

  //       // Create a blob from the response and download the file
  //       const blob = await response.blob();
  //       const url = window.URL.createObjectURL(blob);
  //       const a = document.createElement('a');
  //       a.href = url;
  //       a.download = 'report.pdf'; // You can customize the file name
  //       document.body.appendChild(a);
  //       a.click();
  //       a.remove();
  //     } catch (error) {
  //       console.error('Error generating report:', error);
  //     }
  //   } else {
  //     console.error('Compnay ID is required to generate the report');
  //   }
  // };

  // Custom styles object

  const handleGenerateReport = async () => {
    try {
      setLoadingReport(true);
      const { error, data } = await getReport();
      const url = window.URL.createObjectURL(data);
      const a = document.createElement("a");
      a.href = url;
      a.download = "report.pdf"; // You can customize the file name
      document.body.appendChild(a);
      a.click();
      a.remove();
      if (error) {
        throw new Error(error);
      }
    } catch (error) {
      console.error("Compnay ID is required to generate the report: ", error);
    } finally {
      setLoadingReport(false);
    }
  };

  const getTranslatedTitle = () => {
    const title = getTitleFromRoute(location.pathname).toLowerCase();
    return t(`titles.${title}`, title);
  };

  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      minWidth: "200px",
      backgroundColor: "#ffff",
      border: "0px",
      color: "#4C4C66",
      // borderColor: state.isFocused ? 'blue' : '#ccc',
      boxShadow: state.isFocused ? "none" : "none",
      borderRadius: "10px",
      "&:hover": {
        borderColor: "#000",
      },
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected
        ? "blue"
        : state.isFocused
        ? "#f0f0f0"
        : "#fff",
      color: state.isSelected ? "#fff" : "#4C4C66",
      "&:hover": {
        backgroundColor: "#f0f0f0",
        color: "#4C4C66",
      },
    }),
    menu: (provided) => ({
      ...provided,
      zIndex: 9999,
      backgroundColor: "#F4F6FA",
      color: "#4C4C66",
    }),
  };
  useEffect(() => {
    const site = localSite() || userSite;
    if (site?.value) {
      setSite(site);
    } else {
      setSite(null);
    }
  }, [userSite]);

  const formatTimeAgo = (timestamp) => {
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const now = moment().tz(timezone);
    const date = moment.utc(timestamp).tz(timezone);

    const minutes = now.diff(date, "minutes");
    const hours = now.diff(date, "hours");

    if (minutes < 60) {
      return `${minutes} min${minutes === 1 ? "" : "s"} ago`;
    } else if (hours < 24) {
      return `${hours} hour${hours === 1 ? "" : "s"} ${minutes % 60} min ago`;
    } else {
      return date.format("MM-DD-YYYY, HH:mm");
    }
  };

  useEffect(() => {
    const fetchSites = async () => {
      try {
        const { error, data } = await getSites();
        if (error) {
          throw new Error(error);
        }
        setSitesList(data.sites);
        if (data.sites.length < 1) navigate("/sites");
      } catch (err) {
        setError(err);
        console.error("Failed to fetch sites:", err);
        toast.error("Couldn't load your sites. Retrying automatically.");
      }
    };
    fetchSites();
  }, [sitesRefreshToken]);

  // Full record (Lat/Lng/location) for the currently selected site -- the
  // `site` state above only carries the {label, value} pair the <Select>
  // needs, so look the rest up from the already-fetched sitesList.
  const selectedSiteRecord = (sitesList || []).find(
    (s) => String(s.Site_ID) === String(site?.value)
  ) || null;

  useEffect(() => {
    if (!selectedSiteRecord?.Lat || !selectedSiteRecord?.Lng) {
      setWeather(null);
      return;
    }
    let cancelled = false;
    const fetchWeather = async () => {
      setWeatherLoading(true);
      try {
        const result = await getCurrentWeather(selectedSiteRecord.Lat, selectedSiteRecord.Lng);
        if (!cancelled) setWeather(result);
      } catch (err) {
        console.error("Error fetching weather:", err);
        if (!cancelled) setWeather(null);
      } finally {
        if (!cancelled) setWeatherLoading(false);
      }
    };
    fetchWeather();
    const interval = setInterval(fetchWeather, 15 * 60 * 1000); // refresh every 15 minutes
    return () => {
      cancelled = true;
      clearInterval(interval);
    };
  }, [selectedSiteRecord?.Lat, selectedSiteRecord?.Lng]);

  //fetch notifications
  useEffect(() => {
    const fetchNotifications = async () => {
      try {
        const { error, data } = await getPendingNotifications();
        if (error) {
          throw new Error(error);
        }
        setNotifications(data || []);
      } catch (err) {
        console.error('Error fetching notifications:', err);
      }
    };
    fetchNotifications();
    const interval = setInterval(fetchNotifications, 60000); //get notifications every 60 seconds
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const fetchAlerts = async () => {
      setNotificationsLoading(true);
      // console.log("Fetching latest alerts for site:", userSite, "and company:", userCompany);
      if (userCompany)
        try {
          const params = {
            site: (userSite && userSite.value) || null,
            company: userCompany || null,
          };
          const { error, data } = await getLatestAlerts(
            params.site,
            params.company
          );
          
          // Add this check before mapping
          if (!data || !Array.isArray(data)) {
            console.warn('No alerts data received');
            setAlerts([]);
            setNotificationsLoading(false);
            return;
          }
          
          // Check for error before processing
          if (error) {
            throw new Error(error);
          }
          
          const updatedAlerts = await Promise.all(
            data.map(async (alert) => {
              let siteName = "Unknown Site";
              let zoneName = "Unknown Zone";

              //site name
              if (alert.Site_ID) {
                const { error: siteError, data: siteData } = await siteGet(alert.Site_ID);
                if (!siteError && siteData) {
                  siteName = siteData.Name || "Unknown Site";
                }
              }

              //zone name
              if (alert.Zone_ID) {
                const { error: zoneError, data: zoneData } = await zoneGet(alert.Zone_ID);
                if (!zoneError && zoneData) {
                  zoneName = zoneData.Zone_name || "Unknown Zone";
                }
              }
              
              return {
                ...alert,
                id: alert.Alert_ID || alert.id || `alert-${Math.random()}`,
                alert_type: alert.model_name ? `${alert.model_name} Detected!` : "Alert Detected!",
                time_ago: formatTimeAgo(alert.timestamp),
                seen: alert.Treated ? 1 : 0,
                zone: { Zone_name: zoneName },
                site: { Name: siteName },
              };
            })
          );
          setAlerts(updatedAlerts);
        } catch (err) {
          console.error("Error fetching alerts:", err);
          setAlerts([]); // Set empty array on error
        } finally {
          setNotificationsLoading(false);
        }
    };

    fetchAlerts();
    const interval = setInterval(fetchAlerts, 30000);
    return () => clearInterval(interval);
  }, [userSite, userCompany]);

  // Backend host disk/RAM warning -- admin/superAdmin-only since it's shared
  // infra state, not something a regular company user can act on. toastId
  // dedupes so a still-low reading on the next poll doesn't stack duplicate
  // toasts, while a fresh warning still reappears after the user dismisses it.
  useEffect(() => {
    if (!isAdmin) return;

    const checkHostResources = async () => {
      try {
        const { error, data } = await getHostResources();
        if (error || !data) return;

        if (data.disk_low) {
          toast.warn(
            t("low_disk_space", { free: data.disk_free_gb, defaultValue: `Low disk space on the server: only ${data.disk_free_gb} GB free.` }),
            { toastId: "low-disk-space" }
          );
        }
        if (data.ram_low) {
          toast.warn(
            t("low_ram", { available: data.ram_available_mb, defaultValue: `Low memory on the server: only ${data.ram_available_mb} MB available.` }),
            { toastId: "low-ram" }
          );
        }
      } catch (err) {
        console.error("Error checking host resources:", err);
      }
    };

    checkHostResources();
    const resourceInterval = setInterval(checkHostResources, 5 * 60 * 1000); // every 5 minutes
    return () => clearInterval(resourceInterval);
  }, [isAdmin, t]);

  const handleSiteSelect = (option) => {
    if (!option) {
      localStorage.setItem(
        "site",
        JSON.stringify({ label: null, value: null })
      );
      dispatch(setUserSite({ label: null, value: null }));
      setSite({ label: "", value: "" });
    } else if (option.value) {
      setSite(option);
      dispatch(setUserSite(option));
      localStorage.setItem(
        "site",
        JSON.stringify({ value: option.value, label: option.label })
      );
    }
  };

  const closeModal = () => {
    setIsGenerateReportModalOpen(false);
  };
  const openGenerateReportModal = () => {
    setIsGenerateReportModalOpen(true);
  };

  const toggleNotificationDropdown = () => {
    setIsNotificationDropdownOpen(!isNotificationDropdownOpen);
  };

  const handleMarkAsRead = (notificationId) => {
    setNotifications(notifications.map((n) =>
      n.id === notificationId ? { ...n, seen: 1 } : n
    ));
  };

  const unreadCount = notifications.filter((n) => !n.seen).length;

  const dropdownOptions = [
    { title: t("profile", "Profile"), path: "/settings" },
    { title: t("contact_support", "Contact Support"), onClick: () => setShowContactModal(true) },
  ];

  if (userData?.Role === "superAdmin") {
    dropdownOptions.push({
      title: "Model Definitions",
      path: "/model-definitions",
    });
  }

  dropdownOptions.push({ title: t("logout"), modal: "LogoutModal" });

  dropdownOptions.push({ divider: true });
  dropdownOptions.push({
    info: true,
    icon: "Calendar",
    title: (
      <div className="flex flex-col leading-tight">
        <span className="font-semibold text-[#474747]">
          {currentDateTime.format("dddd, MMMM D, YYYY")}
        </span>
        <span className="text-[#0071BC]">
          {currentDateTime.format("HH:mm:ss")}
        </span>
      </div>
    ),
  });
  if (selectedSiteRecord) {
    dropdownOptions.push({
      info: true,
      icon: "MapPin",
      title: selectedSiteRecord.location || selectedSiteRecord.Name || t("unknown_site"),
    });
    if (weather || weatherLoading) {
      dropdownOptions.push({
        info: true,
        icon: "Sun",
        title: weather
          ? `${Math.round(weather.temperature)}°C · ${weather.description}`
          : t("loading_weather", "Loading weather…"),
      });
    }
  }

  const noAlertsToReport = !notificationsLoading && alerts.length === 0;

  return (
    <header className="pb-5 pt-7 md:pl-20 max-md:pt-3 z-40 h-30 bg-[#f4f8fc] shadow-bottom">
      <Modal
        modal={"GenerateReportModal"}
        isOpen={isGenerateReportModalOpen}
        onClose={closeModal}
      />
      <ContactSupportModal
        showModal={showContactModal}
        onClose={() => setShowContactModal(false)}
        site={site?.value}
      />

      <div className="container flex items-center justify-between  h-full px-6 mx-auto text-purple-600 ">
        {/* <!-- Mobile hamburger --> */}
        {location.pathname != "/rule/settings" && (
          <button
            className="p-1 mr-5  rounded-md md:hidden focus:outline-none focus:shadow-outline-purple"
            onClick={toggleSidebar}
            aria-label={t("menu_aria_label")}
          >
            <Icon className="w-5 h-5 " icon={"Menu"} />
            {/* <Menu className="w-6 h-6" aria-hidden="true" /> */}
          </button>
        )}

        <div
          className={`opacity-90 flex text-gray-600 ${
            getTitleFromRoute(location.pathname) == "Dashboard"
              ? "max-sm:hidden"
              : ""
          } md:text-4xl sm:text-xl font-bold  `}
        >
          {location.pathname == "/rule/settings" ? (
            <div className="flex space-x-1 ">
              <NavLink to="/rules">
                <button>
                  <div className="font-normal  flex ">
                    <div className="mb-1">
                      <Icon icon={"Back"} />
                    </div>
                    <div className="ml-4 max-md:mt-3">{t("rule")}</div>
                  </div>
                </button>
              </NavLink>
              <div className="max-md:mt-3">| {t("settings")}</div>
            </div>
          ) : location.pathname.startsWith("/rule/update/") ? (
            <div className="flex space-x-1 ">
              <NavLink to="/rules">
                <button>
                  <div className="font-normal  flex ">
                    <div className="mb-1">
                      <Icon icon={"Back"} />
                    </div>
                    <div className="ml-4 max-md:mt-3">{t("rule")}</div>
                  </div>
                </button>
              </NavLink>
              <div className="max-md:mt-3">| {t("update")}</div>
            </div>
          ) : (
            getTitleFromRoute(location.pathname)
          )}
        </div>
        <ul className=" md:mr-20 sm:mr-0 flex items-center justify-end flex-shrink-0 space-x-6">

          {/*<!-- Notification Drop Menu --> */}
         
          {/* <!-- Profile menu --> */}
          <li className="relative space-x-4 max-md:space-x-1">
            <div className="  flex space-x-2 items-center flex-row max-md:flex-col ">
              <div className="max-md:hidden step2">
                {sitesList &&
                  location.pathname == "/" &&
                  (site?.label ? (
                    <div className="flex align-items-center gap-5">
                      <Button
                        data-testid="generate-report-open"
                        disabled={loadingReport || noAlertsToReport}
                        tooltip={noAlertsToReport ? "No alerts available to generate a report" : ""}
                        className={noAlertsToReport ? "blur-[1px]" : ""}
                        type="button"
                        onClick={openGenerateReportModal}
                        size="large"
                        color="secondary"
                      >
                        {t("generate_report")}
                      </Button>
                      <Select
                        isClearable={true}
                        styles={customStyles}
                        onChange={handleSiteSelect}
                        placeholder={t("select_site")}
                        defaultValue={site}
                        options={sitesList.map((site) => ({
                          label: String(site.Name),
                          value: site.Site_ID,
                        }))}
                      />
                    </div>
                  ) : (
                    
                    <div className="flex items-center gap-5">
                      <Button
                        data-testid="generate-report-open"
                        disabled={loadingReport || noAlertsToReport}
                        tooltip={noAlertsToReport ? "No alerts available to generate a report" : ""}
                        className={noAlertsToReport ? "blur-[1px]" : ""}
                        type="button"
                        onClick={openGenerateReportModal}
                        size="large"
                        color="secondary"
                      >
                        {t("generate_report")}
                      </Button>
                      <Select
                        isClearable={true}
                        styles={customStyles}
                        onChange={handleSiteSelect}
                        placeholder={"Select Site"}
                        options={sitesList.map((site) => ({
                          label: String(site.Name),
                          value: site.Site_ID,
                        }))}
                      />
                    </div>
                  ))}
              </div>
              <div className="relative">
            {/* <Button
              onClick={toggleNotificationDropdown}
              className="relative p-2 focus:outline-none"
              color=""
              size="small"
            >
              <Icon className="w-6 h-6 text-[#0071BC]" icon={"Bell"} />
              
                <span className="absolute top-0 right-0 inline-flex items-center justify-center px-2 py-1 text-xs font-bold leading-none text-white bg-[#EF8400] rounded-full transform translate-x-1/2 -translate-y-1/2">
                  {unreadCount}
                </span>
              
            </Button> */}
            {/* {isNotificationDropdownOpen && (
              <NotificationDropdown
                notifications={notifications}
                onMarkAsRead={handleMarkAsRead}
              />
            )} */}
          </div>
              <button
                type="button"
                onClick={toggleFullscreen}
                className="p-2 rounded-md text-[#0071BC] hover:bg-gray-100 focus:outline-none"
                title={isFullscreen ? t("exit_fullscreen", "Exit full screen") : t("enter_fullscreen", "Full screen")}
                aria-label={isFullscreen ? t("exit_fullscreen", "Exit full screen") : t("enter_fullscreen", "Full screen")}
              >
                <Icon className="w-5 h-5" icon={isFullscreen ? "FullscreenExit" : "Fullscreen"} />
              </button>
              <div className="min-w-fit step3">
                <DropdownMenu
                  button={{
                    text: userData?.First_name && (
                      <div className="relative inline-flex items-center justify-center w-10 h-10 overflow-hidden bg-bleu_text rounded-full">
                        <span className="font-bold text-white ">
                          {userData?.First_name[0].toUpperCase()}
                          {userData?.Last_name[0].toUpperCase()}
                        </span>
                      </div>
                    ),
                  }}
                  options={dropdownOptions}
                />
              </div>
            </div>
          </li>
        </ul>
      </div>
    </header>
  );
}

export default Header;